<template>
  <ListSectionCard :href="set.url">
    <div class="d-flex">
      <div class="w-25 flex-grow-0 flex-shrink-0">
        <img :src="set.previewImage" :alt="set.name" />
      </div>
      <div class="ms-2 ms-lg-3 d-flex flex-column justify-content-between">
        <div class="highlight-em" v-html="set.highlighted"></div>
        <div class="text-decoration-none">
          <div v-if="difficulty">
            {{ etData.liveSearchData.txtSchwierigkeit }}
            <base-sprite-icon
              v-for="n in 5"
              :key="n"
              width="16"
              height="16"
              :class="{ icon_primary: n <= difficulty }"
              icon="icon_pinsel"
            />
          </div>
          <div v-if="timeAndEffortHHss.hours || timeAndEffortHHss.minutes">
            {{ etData.liveSearchData.txtDauer }}
            <span v-if="timeAndEffortHHss.hours" class="text-primary">
              {{ timeAndEffortHHss.hours }} {{ etData.liveSearchData.txtAbbrevationHours }}
            </span>
            <span v-if="timeAndEffortHHss.minutes" class="text-primary">
              {{ timeAndEffortHHss.minutes }} {{ etData.liveSearchData.txtAbbrevationMinutes }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ListSectionCard>
</template>

<script setup lang="ts">
// import type CustomField from "@/ts/components/Types/CustomField";
import {type SearchResultSet} from "@/ts/components/Types/SearchResult";
import ListSectionCard from "@/components/layout/LiveSearch/ListSectionCard.vue";
import BaseSpriteIcon from "@/components/ui/BaseSpriteIcon.vue";
import type EtDataType from "@/ts/components/Types/EtDataType";

interface Props {
  set: SearchResultSet;
}

const props = defineProps<Props>();
const etData: EtDataType = window.etData;

function customField(
    name: string,
    props?: { set?: { custom?: any[] } },
): number | undefined {
    const field = props?.set?.custom?.find(
        (field) => field.fieldName === name && typeof field.fieldValue === "number",
    );
    return field && !Number.isNaN(Number(field.fieldValue))
        ? Number(field.fieldValue)
        : undefined;
}

const difficulty: number | undefined = customField("difficulty", props);
const timeAndEffort: number | undefined = customField("timeAndEffort", props);

const timeAndEffortHHss = {
    hours: timeAndEffort ? Math.floor(timeAndEffort / 60) : undefined,
    minutes: timeAndEffort ? timeAndEffort % 60 : undefined,
};
</script>

<style scoped lang="scss">
.icon_primary {
  --icon-foreground-color: var(--bs-primary);
}
</style>
